import { Box } from '@primer/react';
import { ColoredCircle } from '@upright/ui/common/generic/components/colored-circle-for-legend';
import styled from 'styled-components';
import { TableColumn } from '../../../../../common/generic/content/tables/sortable-table';
import { getTextStyle } from '../../../../../common/generic/content/texts/bou-text/text-style';
import { ImpactChartDataSeries } from '../../../../../common/upright/model/output/scores/net-impact-chart/types';
import { TextCell } from '../../../../../common/upright/model/output/tables/table-styles';

export function getRenderLegendNameColumnWithColor(chartData: ImpactChartDataSeries[]) {
  const nameColumn: TableColumn<ImpactChartDataSeries> = {
    key: 'name',
    title: <></>,
    titleAlign: 'left',
    comparator: (a, b) => {
      return (a.name || '').localeCompare(b.name || '');
    },
    values: chartData,
    renderCell: (value: ImpactChartDataSeries, columnIndex: number) => {
      return (
        <TextCell key={columnIndex}>
          <TextCellInner>
            <Box marginRight={'10px'}>
              <ColoredCircle color={value.color} />
            </Box>
            {value.name}
          </TextCellInner>
        </TextCell>
      );
    },
    renderExportValue: (value: ImpactChartDataSeries) => value.name || '',
  };
  return nameColumn;
}

const TextCellInner = styled.div`
  ${getTextStyle({ size: 'xxs' })};
  display: flex;
  align-items: center;
  margin-right: 1em;
`;
